<div class="dialog">
  @for (config of buttonConfig(); track $index) {
    <button
      pButton
      pRipple
      [loading]="config.loading?.() ?? false"
      [class]="config.cssClass"
      [class.dialog__button]="buttonConfig().length === 1"
      (click)="handleClick(config)">
      {{ config.label }}
    </button>
  }
</div>
